<script>
	import { max, descending, ascending } from "d3-array";
	import dataRaw from "./lib/tomaten.json";
	import { categoriesById } from "./lib/categories";
	import { format } from "./lib/utils.js";
	import Buttons from "./components/Buttons.svelte";

	let data = dataRaw.filter((d) => d.Bio !== "Bio");

	const frmt = format(2, true);

	data.forEach((d) => {
		d["CO2 pro Kilo"] /= 1000;
		d.icon = "strauch";
		if (d.Name === "Cherrytomaten") d.icon = "cherry";
		if (d.Verpackung === "Dose") {
			d.VerpackungD = "aus der Dose";
			d.icon = "can";
		}
		if (d.Verpackung === "Tetrapack") {
			d.VerpackungD = "im Tetrapack";
			d.icon = "tetra";
		}
		if (d.Verpackung === "Glasflasche") {
			d.VerpackungD = "in der Glasflasche";
			d.icon = "bottle";
		}
		if (!d.Verpackung) {
			d.Verpackung = "frisch";
			d.VerpackungD = "frisch";
		}
		if (d.Bio) d.Name += " Bio";
	});

	const mPreis = max(data, (d) => d["Preis pro Kilo"]);
	const mCO2 = max(data, (d) => d["CO2 pro Kilo"]);

	let sort = "co2";
	const options = [
		{ label: "CO₂", value: "co2" },
		{ label: "Preis", value: "preis" },
	];

	function dosort() {
		if (sort === "preis") data.sort((a, b) => ascending(a["Preis pro Kilo"], b["Preis pro Kilo"]));
		if (sort === "co2") data.sort((a, b) => ascending(a["CO2 pro Kilo"], b["CO2 pro Kilo"]));
		data = data;
	}

	$: sort && dosort();

	let open = false;

	const offset = -70;

	function scrollTo(elem) {
		const tBody = document.documentElement.getBoundingClientRect().top;
		const tE = elem.getBoundingClientRect().top;
		const t = tE - tBody;
		if (tE < 0) window.scrollTo({ top: t + offset, behavior: "smooth" });
	}

	let container;

	function toggle() {
		if (open) {
			scrollTo(container);
			setTimeout(() => {
				open = false;
			}, 600);
		} else {
			open = true;
		}
	}
</script>

<div class="tomaten" class:open bind:this={container}>
	<div class="tomaten-toggle">
		<Buttons bind:value={sort} {options} prefix="Sortiert nach" compact={true} />
	</div>

	<div class="tomaten-content">
		{#each data as d, i (i)}
			<div class="tomaten-item">
				<div class="tomaten-item__icon-container">
					<div
						class="tomaten-item__icon"
						style:background-image={`url('${PATH}/tomaten-icons/${d.icon}.svg')`}
					/>
					{#if d.Bio}<span class="bio">BIO</span>{/if}
				</div>
				<div class="tomaten-item__meta">
					<div class="tomaten-item__name">
						<span class="nw">{d.Name}<span class="mobile">, </span></span>
					</div>
					<div class="tomaten-item__packaging">
						<span class="nw">
							<span class="desktop">{d.VerpackungD}</span>
							<span class="mobile">{d.Verpackung}, </span>
							{#if d.Marke}
								<span class="desktop">({d.Marke})</span>
								<span class="mobile">{d.Marke}, </span>
							{/if}
						</span>
					</div>
					<div class="tomaten-item__origin">
						<span class="desktop">Herkunft: </span>{d.Herkunft}
					</div>
				</div>
				<div class="tomaten-item__data {sort}">
					<div class="tomaten-item__bar-container">
						<div class="tomaten-item__bar-label">Preis:</div>
						<div class="tomaten-item__bar-wrapper">
							<div
								class="tomaten-item__bar blue"
								style:width={(d["Preis pro Kilo"] / mPreis) * 100 + "%"}
							>
								<div class="tomaten-item__value" class:inside={d["Preis pro Kilo"] / mPreis > 0.8}>
									{frmt(d["Preis pro Kilo"])} €
									{#if i === 0}
										pro Kilo
									{/if}
								</div>
							</div>
						</div>
					</div>
					<div class="tomaten-item__bar-container">
						<div class="tomaten-item__bar-label">CO₂:</div>
						<div class="tomaten-item__bar-wrapper">
							<div
								class="tomaten-item__bar red"
								style:width={(d["CO2 pro Kilo"] / mCO2) * 100 + "%"}
							>
								<div class="tomaten-item__value" class:inside={d["CO2 pro Kilo"] / mCO2 > 0.8}>
									{frmt(d["CO2 pro Kilo"])}kg CO₂
									{#if i === 0}
										pro Kilo
									{/if}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		{/each}
	</div>
	<div class="moreless" class:more={!open} on:click={toggle}>
		{#if !open}
			<span>mehr anzeigen</span>
		{:else}
			<span>zuklappen</span>
		{/if}
	</div>
</div>

<style>
	.tomaten {
		background-color: #dedede;
		border-radius: 6px;
		font-family: "Franklin Gothic FS", Helvetica, Arial, sans-serif;
		font-size: 16px;
		line-height: 17px;
		margin-bottom: 50px;
		position: relative;
	}

	.tomaten-content {
		padding: 15px;
		/* max-height: 465px; */
		overflow: hidden;
	}

	/* .tomaten-content::after {
		content: " ";
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 65px;
		border-radius: 0 0 6px 6px;
		background: linear-gradient(
			to top,
			rgb(222, 222, 222) 0%,
			rgb(222, 222, 222) 20%,
			rgba(222, 222, 222, 0) 100%
		);
	} */

	.open .tomaten-content {
		max-height: none;
	}

	.open .tomaten-content::after {
		display: none;
	}

	.tomaten-item {
		display: flex;
		align-items: center;
		height: 71px;
	}

	.tomaten-item__icon-container {
		margin-right: 10px;
		flex: 0 0 48px;
		position: relative;
	}

	.tomaten-item__icon {
		height: 48px;
		width: 48px;
		background-size: contain;
		background-position: center center;
		background-repeat: no-repeat;
	}

	.tomaten-item__meta {
		flex: 0 0 180px;
		padding: 10px 0;
	}

	.tomaten-item__data {
		flex: 1 0 1px;
		position: relative;
		display: flex;
		flex-direction: column;
	}

	.tomaten-item__data.co2 {
		flex-direction: column-reverse;
	}

	.tomaten-item__name {
		font-weight: 500;
		white-space: nowrap;
	}

	.tomaten-item__packaging,
	.tomaten-item__origin {
		font-size: 14px;
		line-height: 17px;
	}

	.tomaten-item__bar-container {
		position: relative;
		height: 16px;
		margin: 3px 0;
		display: flex;
	}

	.tomaten-item__bar-label {
		flex: 0 0 40px;
		font-size: 14px;
	}
	.tomaten-item__bar-wrapper {
		flex: 1 0 1px;
		height: 100%;
		position: relative;
	}

	.tomaten-item__bar {
		height: 16px;
		background-color: #666;
		border-radius: 1px;
		position: absolute;
		min-width: 1px;
		top: 50%;
		left: 0;
		transform: translateY(-50%);
		background: repeating-linear-gradient(45deg, #666 0px, #666 5px, #444 5px, #444 10px);
	}

	.tomaten-item__bar.blue {
		background-color: #fff;
		background-image: repeating-linear-gradient(
			45deg,
			rgba(127, 170, 233, 0.85) 0px,
			rgba(127, 170, 233, 0.85) 5px,
			rgb(127, 170, 233) 5px,
			rgb(127, 170, 233) 10px
		);
	}

	.tomaten-item__bar.red {
		background-color: #fff;
		background-image: repeating-linear-gradient(
			45deg,
			rgb(233, 135, 145, 0.85) 0px,
			rgb(233, 135, 145, 0.85) 5px,
			rgb(233, 135, 145, 1) 5px,
			rgb(233, 135, 145, 1) 10px
		);
	}

	.tomaten-item__value {
		white-space: nowrap;
		position: absolute;
		left: 100%;
		padding: 0 7px;
		top: 50%;
		transform: translateY(-50%);
		font-weight: 500;
		font-size: 14px;
	}

	.tomaten-item__value.inside {
		left: auto;
		right: 0;
		/*color: #000;*/
		/*
    text-shadow:
      1px 1px 0 rgba(255, 255, 255, 1),
      1px -1px 0 rgba(255, 255, 255, 1),
      -1px 1px 0 rgba(255, 255, 255, 1),
      -1px -1px 0 rgba(255, 255, 255, 1);
    */
		text-shadow: 1px 1px 0 #ededed, 1px -1px 0 #ededed, -1px 1px 0 #ededed, -1px -1px 0 #ededed;
	}

	.tomaten-toggle {
		background: #ededed;
		padding: 20px 0 20px;
		border-radius: 6px 6px 0 0;
	}

	.bio {
		font-size: 11px;
		font-weight: bold;
		background-color: #31e085;
		border-radius: 3px;
		padding: 0 3px;
		position: relative;
		top: -2px;
		margin-left: 2px;
	}

	.tomaten-item__icon-container .bio {
		position: absolute;
		top: -3px;
		right: -3px;
		margin: 0;
		border: 1px solid #ededed;
		font-size: 10px;
		line-height: 12px;
	}

	.moreless {
		display: none;
		width: 40px;
		height: 40px;
		background-color: #f9d914;
		border-radius: 50%;
		cursor: pointer;
		position: absolute;
		bottom: -20px;
		left: calc(50% - 20px);
		transform-origin: center center;
		transform: scale(0.8);
		transition: transform 0.3s ease;
	}

	.moreless:hover {
		transform: scale(0.9);
	}

	.moreless::before {
		content: " ";
		width: 20px;
		height: 2px;
		background: #000;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.more::after {
		content: " ";
		width: 2px;
		height: 20px;
		background: #000;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.moreless span {
		white-space: nowrap;
		font-size: 17.5px;
		line-height: 18px;
		font-weight: 500;
		position: absolute;
		bottom: -20px;
		left: 50%;
		transform: translateX(-50%);
	}

	.mobile {
		display: none;
	}

	@media (max-width: 480px) {
		.tomaten {
			font-size: 14px;
			line-height: 17px;
		}
		.tomaten-content {
			padding: 10px 10px 10px 3px;
			max-height: 470px;
		}

		.tomaten-content::after {
			content: " ";
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 65px;
			border-radius: 0 0 6px 6px;
			background: linear-gradient(
				to top,
				rgb(222, 222, 222) 0%,
				rgb(222, 222, 222) 20%,
				rgba(222, 222, 222, 0) 100%
			);
		}

		.tomaten-item__icon-container {
			flex: 0 0 38px;
			margin-right: 7px;
		}

		.tomaten-item__icon {
			width: 38px;
			height: 38px;
		}

		.tomaten-item {
			flex-wrap: wrap;
			height: auto;
			margin-bottom: 20px;
		}

		.tomaten-item__meta {
			flex-basis: calc(100% - 45px);
		}

		.tomaten-item__date {
			flex-basis: 100%;
		}

		.tomaten-item__name,
		.tomaten-item__packaging,
		.tomaten-item__origin {
			display: inline-block;
		}

		.tomaten-item__bar-label {
			flex: 0 0 45px;
			text-align: right;
			padding-right: 5px;
			box-sizing: border-box;
		}

		.moreless {
			display: block;
		}

		.mobile {
			display: inline;
		}

		.desktop {
			display: none;
		}
	}
</style>
